
import { useContext, useEffect, useLayoutEffect, useState } from 'react';
import { DashboardContext } from '../../../contextApi/DashboardContext';
import { media } from '../../../dataSets/media';
import { AppContext } from '../../../contextApi/ContextApi';

export default function CategoryCard({website, item}) {
  const {setCurrentWebsite, fetchImage, setToastMessage, messagesOptions} = useContext(AppContext);
  const { handleDeleteItem, handleUpdateCategoryName } = useContext(DashboardContext);
  
  const [xFlag, setXFlag] = useState(false);
  const [imgURL, setImgURL] = useState();
  const [editCategoryName, setEditCategoryName] = useState(false);
  const [newCategoryName, setNewCategoryName] = useState(item.name);
  useLayoutEffect(()=>{
    fetchImage(website, item, setImgURL);
  },[])
  useEffect(()=>{
    if((item.name===newCategoryName && !editCategoryName) || editCategoryName){
      return;
    }
    handleUpdateCategoryName(website.id, website.settings.categories, item._id, "name", newCategoryName, "settings.categories", setCurrentWebsite);
  },[editCategoryName])

  return (
    <div className='categoryCard'>
        <div className='categoryCard_name'>
          <img src={media.pencil_icon} alt="pencil_edit_icon" onClick={()=>{setEditCategoryName(!editCategoryName)}}/>
          {editCategoryName ?
            <input type='text' value={newCategoryName.slice(0,40)} placeholder={item.name} onChange={(e)=>{setNewCategoryName(e.target.value)}}/> :
            <p>{item.name.length > 20 ? `${item.name.slice(0,20)}...` : item.name}</p>
          }
        </div>
        <div className='categoryCard_imgDiv'>
          <div className='categoryCard_img' style={{backgroundImage: `url(${imgURL || website?.settings?.logo?.imgURL || media.webingoLogo})`, backgroundSize:"cover"}} onMouseEnter={()=>{setXFlag(true)}} onMouseLeave={()=>{setXFlag(false)}}>
            {xFlag && <div onMouseEnter={()=>{setXFlag(true)}} className='categoryCard_xBtn' onClick={()=>{handleDeleteItem(website?.id, "settings.categories", item, setToastMessage, messagesOptions)}}>x</div>}
          </div>
        </div>
    </div>
  )
}
